import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from '../../store/toastStore';
import { monthApprovalPath } from './monthApprovalModel';
import { formatMonthName } from './monthLabels';

/**
 * D-319 s.6 - "לפני שמתחילים לעבוד צריך לאשר את {חודש}" with the button "לאישור {חודש}".
 * Shown when a start is pressed (or refused by the server) while a month waits for approval.
 */
export function useMonthApprovalNotice() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  return useCallback((month: string | null | undefined) => {
    if (!month) return;
    const name = formatMonthName(month, i18n.language);
    toast('warning', t('monthApproval.blocked.message', { month: name }), {
      action: { label: t('monthApproval.blocked.go', { month: name }), onClick: () => navigate(monthApprovalPath(month)) },
      duration: 10_000,
    });
  }, [t, i18n.language, navigate]);
}
